import adgPlayers from '../data/adg.js';
import AdgLogo from '../assets/team-ace.png';
import RatingPage from './RatingPage';

const AdgRatings = () => {
  return (
    <RatingPage playerData={adgPlayers}>
      Team Ace <img src={AdgLogo} alt="" />
    </RatingPage>
  );
};

export default AdgRatings;
